// extracted by mini-css-extract-plugin
module.exports = {"wrapperDate":"techhome_wrapperDate_1FKYw"};